import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, share } from 'rxjs';
import { User } from 'src/app/data/model/user';
import { AppActions, AppSelectors } from 'src/app/store/app-store';
import { PasswordResetDialogComponent } from '../password-reset-dialog/password-reset-dialog.component';
import { RegisterTotpDeviceDialogComponent } from '../register-totp-device-dialog/register-totp-device-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-user-menu',
  standalone: false,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements OnInit {
  public user$: Observable<User | null> | undefined;

  constructor(
    private store: Store,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.user$ = this.store.select(AppSelectors.selectUser);
  }

  getUserName(user: User) {
    return user.first_name && user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.username;
  }

  openResetDialog(user:User) {
    this.dialog.open(PasswordResetDialogComponent, {
      width: '400px',
      data: { user: user },
    });
  }

  openRegisterTOTPDialog(user:User) {
    this.dialog.open(RegisterTotpDeviceDialogComponent, {
      width: '400px',
      data: { user: user },
    });
  }

  logOut() {
    this.store.dispatch(AppActions.logOut());
  }
}
